import React from "react";
import { Route } from "react-router";
import IngredientList from "./ingredientList";
import IngredientForm from "./ingredientForm";
import MovementHistory from "./movementHistory";
import RecipeList from "./recipeList";
import RecipeForm from "./recipeForm";
import FoodCostList from "./foodCostList";
import SupplierList from "./supplierList";
import SupplierForm from "./supplierForm";
import PurchaseOrderList from "./purchaseOrderList";
import PurchaseOrderForm from "./purchaseOrderForm";
import PurchaseOrderDetail from "./purchaseOrderDetail";
import ReceiveForm from "./receiveForm";
import StockCountList from "./stockCountList";
import StockCountForm from "./stockCountForm";
import StockCountDetail from "./stockCountDetail";
import WasteReportPage from "./wasteReport";
import ReportWaste from "./reportWaste";
import ProductionRecipeList from "./productionRecipeList";
import ProductionRecipeForm from "./productionRecipeForm";
import ProductionBatchList from "./productionBatchList";
import StartBatch from "./startBatch";
import ProductionBatchDetail from "./productionBatchDetail";
import CostDrivers from "./costDrivers";
import TheoreticalVsActual from "./theoreticalVsActual";
import LowStockAlerts from "./lowStockAlerts";
import InventoryReports from "./inventoryReports";

const Inventory: React.FC = () => (
  <div className="container py-4">
    <Route exact path="/inventory" component={IngredientList} />
    <Route path="/inventory/new" component={IngredientForm} />
    <Route path="/inventory/edit/:id" component={IngredientForm} />
    <Route exact path="/inventory/recipes" component={RecipeList} />
    <Route path="/inventory/recipes/new" component={RecipeForm} />
    <Route path="/inventory/recipes/edit/:id" component={RecipeForm} />
    <Route exact path="/inventory/suppliers" component={SupplierList} />
    <Route path="/inventory/suppliers/new" component={SupplierForm} />
    <Route path="/inventory/suppliers/edit/:id" component={SupplierForm} />
    <Route exact path="/inventory/purchases" component={PurchaseOrderList} />
    <Route path="/inventory/purchases/new" component={PurchaseOrderForm} />
    <Route
      exact
      path="/inventory/purchases/:id"
      component={PurchaseOrderDetail}
    />
    <Route path="/inventory/purchases/:id/receive" component={ReceiveForm} />
    <Route exact path="/inventory/counts" component={StockCountList} />
    <Route path="/inventory/counts/new" component={StockCountForm} />
    <Route exact path="/inventory/counts/:id" component={StockCountDetail} />
    <Route exact path="/inventory/waste" component={WasteReportPage} />
    <Route path="/inventory/waste/report" component={ReportWaste} />
    <Route exact path="/inventory/production" component={ProductionBatchList} />
    <Route
      exact
      path="/inventory/production/recipes"
      component={ProductionRecipeList}
    />
    <Route
      path="/inventory/production/recipes/new"
      component={ProductionRecipeForm}
    />
    <Route
      path="/inventory/production/recipes/edit/:id"
      component={ProductionRecipeForm}
    />
    <Route path="/inventory/production/new" component={StartBatch} />
    <Route
      exact
      path="/inventory/production/:id"
      component={ProductionBatchDetail}
    />
    <Route exact path="/inventory/alerts" component={LowStockAlerts} />
    <Route exact path="/inventory/food-cost" component={FoodCostList} />
    <Route exact path="/inventory/cost-drivers" component={CostDrivers} />
    <Route
      exact
      path="/inventory/theoretical-vs-actual"
      component={TheoreticalVsActual}
    />
    <Route exact path="/inventory/reports" component={InventoryReports} />
    <Route exact path="/inventory/movements" component={MovementHistory} />
    <Route
      path="/inventory/movements/:ingredient_id"
      component={MovementHistory}
    />
  </div>
);

export default Inventory;
